import React, { useState } from 'react';
import { DeleteFaq } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { SupportController } from '../../controllers';

const DeleteFaqContainer = ({ closeModal, items }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async (id) => {
        setLoading(true);
        const { status, errorMessage } = await SupportController.deleteFaq(id);
        if (status === constant.Success) {
            SupportController.getFaqs();
            MimaToastUtil.success({ message: constant.Success })
            setLoading(false);
            return closeModal();
        } else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }

    const goBack = () => {
        closeModal();
    }
    return (
        <DeleteFaq
            loading={loading}
            handleDelete={handleDelete}
            closeModal={closeModal}
            goBack={goBack}
            items={items}
        />
    )
}
export default DeleteFaqContainer;